"use client";
import React, { useState, useEffect, useRef } from "react";
import { CategoryProps, CategoryItem } from "./type";
import ExpandVector from "@/assets/icons/ExpandVector.svg";
import SafeLink from "@/components/SafeLink";
import { buildSearchUrl } from "../../util";
import styles from "./secondLevelCate.module.scss";

const SecondLevelCate: React.FC<CategoryProps> = ({ data = [], searchParams, basePath }) => {
  const { l1: _l1, l2: _l2, l3: _l3 } = searchParams;
  const [l1, l2, l3] = [~~_l1, ~~_l2, ~~_l3];
  const currentCategory = data.find((item: CategoryItem) => ~~item.id === l1);
  const l2CategoryList = currentCategory?.childrenList || [];
  const [l2Clicked, setL2Clicked] = useState(l2);

  const categoryRef = useRef<HTMLDivElement>(null);
  const [expand, setExpand] = useState<boolean>(false); // 控制二级类目展开收起
  const [isShowExpand, setIsShowExpand] = useState<boolean>(false); // 控制是否展示展开收起

  useEffect(() => {
    if (categoryRef.current) {
      const height = categoryRef.current.scrollHeight;
      setIsShowExpand(height > 46);
    }
  }, []);

  const handleExpandCate = () => {
    setExpand(!expand);
  };

  return l2CategoryList.length ? (
    <div className={styles["thirld-category-container"]}>
      <div className={styles["category-wrapper"]} style={{ height: expand ? "auto" : 46 }} ref={categoryRef}>
        {l2CategoryList.map((category) => (
          <SafeLink
            key={category.id}
            href={buildSearchUrl(searchParams, { l2: String(category.id), l3: undefined, k: category.cateName, page: '1' }, { basePath })}
            onClick={() => {
              setL2Clicked(category.id);
            }}
            scroll={false}
          >
            <div className={`${styles["category-item"]} ${l2Clicked === category.id ? styles["category-selected"] : ""}`}>{category.cateName}</div>
          </SafeLink>
        ))}
      </div>
      {isShowExpand && (
        <div className={styles["expand-wrapper"]} onClick={handleExpandCate}>
          <ExpandVector className={styles[expand ? "expand" : "collapse"]} />
        </div>
      )}
    </div>
  ) : null;
};

export default SecondLevelCate;
